import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
//@ts-ignore

import { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import useIsMobile from "@hooks/useIsMobile";
import { trackEvents } from "@/common/events/events";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useCMS } from "@hooks/useCMS";
import useLocalStorage from "@hooks/useLocalStorage";
import useHighlightOverlay from "@hooks/useHighlightOverlay";
var LOCAL_STORAGE_KEY = "car_compare_data";
var CarCompare = /*#__PURE__*/createContext(undefined);
var CarCompareProvider = function CarCompareProvider(_ref) {
  var children = _ref.children;
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    navigateTo = _useHelpers.navigateTo;
  var location = useLocation();
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var isMobile = useIsMobile();
  var _useState = useState({
      cars: [],
      maxCars: 2,
      referral_location: "",
      showComparison: false
    }),
    bigData = _useState[0],
    setBigData = _useState[1];
  var _useHighlightOverlay = useHighlightOverlay({
      selector: ".highlightme",
      intervalTime: 1500,
      overlayColor: "rgba(0, 0, 0, 0.4)",
      zIndexBase: 9999999
    }),
    start = _useHighlightOverlay.start,
    stop = _useHighlightOverlay.stop;
  var isDesktop = !isMobile;
  var lang = useLang();
  var _useLocalStorage = useLocalStorage(),
    getLocalStorage = _useLocalStorage.getLocalStorage,
    setLocalStorage = _useLocalStorage.setLocalStorage;
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  useEffect(function () {
    var storedData = getLocalStorage(LOCAL_STORAGE_KEY);
    if (storedData) {
      try {
        var parsedData = JSON.parse(storedData);
        setBigData(parsedData);
      } catch (error) {
        console.error("Failed to parse localStorage data", error);
      }
    }
  }, []);
  useEffect(function () {
    setLocalStorage(LOCAL_STORAGE_KEY, JSON.stringify(bigData));
  }, [bigData]); // This only updates localStorage when bigData changes

  var triggerComparisonEvent = function triggerComparisonEvent(compareStatus) {
    if (compareStatus) {
      start();
      trackEvents("comparison_on", {
        referral_location: getLocationNameFromPathName(location.pathname)
      });
    } else {
      trackEvents("comparison_off", {
        referral_location: getLocationNameFromPathName(location.pathname)
      });
    }
  };
  var isAddCarAllowed = function isAddCarAllowed() {
    var allowedUrls = ["/filters", "/autos", "/user/favorite", "/deal", "/en/filters", "/en/autos", "/en/user/favorite", "/en/deal"];
    return allowedUrls.some(function (url) {
      return location.pathname.startsWith(url);
    });
  };
  var isCompareBarAllowed = function isCompareBarAllowed() {
    var allowedUrls = ["/filters", "/autos", "/user/favorite", "/deal", "/en/filters", "/en/autos", "/en/user/favorite", "/en/deal"];
    return allowedUrls.some(function (url) {
      return location.pathname.startsWith(url);
    });
  };
  var stopOverLay = function stopOverLay() {
    stop();
  };
  var hasCarsToCompare = function hasCarsToCompare() {
    var _bigData$cars;
    return (bigData === null || bigData === void 0 ? void 0 : (_bigData$cars = bigData.cars) === null || _bigData$cars === void 0 ? void 0 : _bigData$cars.length) > 0;
  };
  var canStartComparison = function canStartComparison() {
    return bigData.cars.length > 1;
  };
  var toggleCarCompare = function toggleCarCompare() {
    resetAllCars();
    triggerComparisonEvent(!(bigData !== null && bigData !== void 0 && bigData.showComparison));
    setBigData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        showComparison: !(bigData !== null && bigData !== void 0 && bigData.showComparison)
      });
    });
  };
  var isCarIncluded = function isCarIncluded(carId) {
    return bigData.cars.some(
    //@ts-ignore
    function (car) {
      return parseInt(car.id, 10) === parseInt(carId, 10);
    });
  };
  var canAddMoreCars = function canAddMoreCars() {
    return bigData.cars.length < bigData.maxCars;
  };
  var addCar = function addCar(car) {
    if (canAddMoreCars() && !isCarIncluded(parseInt(car.id, 10))) {
      trackEvents("compare_car_select", {
        user_id: isLoggedIn ? "9665" + user.phone_number : "null",
        post_id: car.id,
        referral_location: getLocationNameFromPathName(location.pathname),
        post_make: car.g4_data_layer.post_make,
        post_model: car.g4_data_layer.post_model,
        post_year: car.g4_data_layer.post_year
      });
      setBigData(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          cars: [].concat(_toConsumableArray(prev.cars), [car]) // Add the new car to the existing list
        });
      });
      return true;
    }
    return false;
  };
  var removeCar = function removeCar(carId) {
    var _carToRemove$g4_data_, _carToRemove$g4_data_2, _carToRemove$g4_data_3;
    var carToRemove = bigData.cars.find(function (car) {
      return parseInt(car.id, 10) === carId;
    });
    trackEvents("compare_car_remove", {
      // user_id: isLoggedIn ? "9665" + user.phone_number : "null",
      post_id: carToRemove.id,
      referral_location: getLocationNameFromPathName(location.pathname),
      post_make: (_carToRemove$g4_data_ = carToRemove.g4_data_layer) === null || _carToRemove$g4_data_ === void 0 ? void 0 : _carToRemove$g4_data_.post_make,
      post_model: (_carToRemove$g4_data_2 = carToRemove.g4_data_layer) === null || _carToRemove$g4_data_2 === void 0 ? void 0 : _carToRemove$g4_data_2.post_model,
      post_year: (_carToRemove$g4_data_3 = carToRemove.g4_data_layer) === null || _carToRemove$g4_data_3 === void 0 ? void 0 : _carToRemove$g4_data_3.post_year,
      post_condition: carToRemove.condition_id
    });
    setBigData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        cars: prev.cars.filter(function (car) {
          return parseInt(car.id, 10) !== carId;
        })
      });
    });
  };
  var resetAllCars = function resetAllCars() {
    setBigData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        cars: []
      });
    });
  };
  var getLocationNameFromPathName = function getLocationNameFromPathName(pathname) {
    if (pathname.indexOf("/autos") > -1) return "autos";
    if (pathname.indexOf("/user/favorite") > -1) return "favorite";
    var locationName = pathname.split("/").filter(function (item) {
      return item !== "";
    });
    return locationName[0];
  };
  var updateCarList = function updateCarList(carList) {
    // resetAllCars();
    setBigData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        cars: carList // Force the type to match
      });
    });
  };
  return /*#__PURE__*/React.createElement(CarCompare.Provider, {
    value: {
      canStartComparison: canStartComparison,
      getLocationNameFromPathName: getLocationNameFromPathName,
      isCarIncluded: isCarIncluded,
      canAddMoreCars: canAddMoreCars,
      addCar: addCar,
      removeCar: removeCar,
      stopOverLay: stopOverLay,
      toggleCarCompare: toggleCarCompare,
      triggerComparisonEvent: triggerComparisonEvent,
      bigData: bigData,
      hasCarsToCompare: hasCarsToCompare,
      resetAllCars: resetAllCars,
      isCompareBarAllowed: isCompareBarAllowed,
      isAddCarAllowed: isAddCarAllowed,
      updateCarList: updateCarList
    }
  }, children);
};
var useCarCompareContext = function useCarCompareContext() {
  var context = useContext(CarCompare);
  if (!context) {
    throw new Error("useCarCompareContext must be used within a CarCompareProvider");
  }
  return context;
};
export { CarCompareProvider, useCarCompareContext };